var render, staticRenderFns
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cfc1dfa')) {
      api.createRecord('3cfc1dfa', component.options)
    } else {
      api.reload('3cfc1dfa', component.options)
    }
    
  }
}
component.options.__file = "src/components/mixins/Invoices.vue"
export default component.exports